import ComicBlock from './ComicBlock.vue'
import NPCTalkBlock from './NPCTalkBlock.vue'
import MoveToStageBtn from './MoveToStageBtn.vue'
import QuestionPart from './QuestionPart.vue'
import StoryImage from './StoryImage.vue'
import MapLink from './MapLink.vue'

const Components = [
  ComicBlock, NPCTalkBlock, MoveToStageBtn, QuestionPart, StoryImage, MapLink
]

const install = function (Vue) {
 Components.forEach(component => {
   Vue.component(component.name, component)
 })
}

export default {
 install
}
